import UnderConstruction from "../Components/UnderConstruction";

export default function Privacy() {
  return <UnderConstruction />;
}
